import React, { Suspense } from 'react';

import { Button } from 'js/components/common/Button';
import { JumioIframe } from 'js/app/components/main/JumioIframe';

import { useInDesktop } from 'js/app/hooks/device/hooks/useMediaQuery';

import {
    JUMIO_STEPS,
    JUMIO_POPUP_IFRAME_DESKTOP_HEIGHT,
    JUMIO_POPUP_IFRAME_MOBILE_HEIGHT,
    JUMIO_POPUP_IFRAME_TYPE_HEIGHT
} from '../constants';

import style from '../JumioPopupUploader.scss';

export const JumioStepIframe = ({ translate, setCurrentStep, documentType, isHideBackButton }) => {
    const isDesktop = useInDesktop();

    const configForJumio = {
        documentType,
        className: style.jumioFrame,
        heightUnit: JUMIO_POPUP_IFRAME_TYPE_HEIGHT,
        height: isDesktop ? JUMIO_POPUP_IFRAME_DESKTOP_HEIGHT : JUMIO_POPUP_IFRAME_MOBILE_HEIGHT
    };

    return (
        <div className={style.frameContainer}>
            <Suspense fallback="">
                <JumioIframe config={configForJumio} />
            </Suspense>

            {!isHideBackButton && (
                <Button size='medium' onClick={() => setCurrentStep(JUMIO_STEPS.start)}>
                    {translate('button.back')}
                </Button>
            )}
        </div>
    );
};
